//Google Tag Manager service

import { localStorageKeyNames } from "../utils/constants";

window.dataLayer = window.dataLayer || [];

const getAuthInfoFromLocalStorage = () => {
    let user_id = '';
    let logged_in = false;
    const authInfo = localStorage.getItem(localStorageKeyNames.auth);
    if (authInfo) {
        const authData = JSON.parse(authInfo);
        logged_in = authData.isLogged;
        user_id = authData.user?.id || '';
    }
    return { user_id, logged_in };
}

export const pushPageView = (section: string) => {
    const { user_id, logged_in } = getAuthInfoFromLocalStorage();
    window.dataLayer.push({
        event: "page_view",
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
        language: navigator.language,
        user_id,
        logged_in,
        section,
        user_type: 'consumidor',
    })
}

export const pushViewOrSelectPromotion = (isView: boolean, promotion_id: string, promotion_name: string) => {
    const { user_id } = getAuthInfoFromLocalStorage();
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: isView ? 'view_promotion' : 'select_promotion',
        ecommerce: {
            user_id,
            section: isView ? undefined : 'Home',
            user_type: 'consumidor',
            items: [
                {
                    item_id: "1", // Este valor por ahora es fijo
                    price: '00.00', // Este valor por ahora es fijo
                    item_name: "Producto genérico", // Este valor por ahora es fijo
                    promotion_id,
                    promotion_name,
                    creative_name: "Banner Principal", // Este valor es fijo
                    creative_slot: "banner_superior", // Este valor es fijo
                    item_category: "Estático", // Este valor por ahora es fijo
                    quantity: 1, // Este valor por ahora es fijo
                    location_id: "/tienda_lista_productos",
                    index: 1, // Este valor por ahora es fijo
                }
            ]
        }
    });
}

export const pushEvent = (event: any) => {
    window.dataLayer.push(event)
}

export const pushShowCoupon = (promotion_id: string, promotion_name: string, coupon_code: string) => {
    const { user_id } = getAuthInfoFromLocalStorage();
    window.dataLayer.push({
        event: 'show_coupon',
        section: 'cupon',
        user_id,
        user_type: 'consumidor',
        promotion_id,
        promotion_name,
        creative_name: 'Banner Principal',
        creative_slot: 'banner_superior',
        coupon: coupon_code,
    })
}

export const pushInteractionEvent = (event: string, label: string, section: string = 'Home') => {
    const { user_id } = getAuthInfoFromLocalStorage();
    window.dataLayer.push({
        event,
        section,
        user_id,
        user_type: 'consumidor',
        label,
    })
}

export const pushWalkthroughEvent = (label: string, step: number) => {
    const { user_id } = getAuthInfoFromLocalStorage();
    window.dataLayer.push({
        event: "walkthrough",
        section: "Home",
        user_id,
        user_type: 'consumidor',
        label,
        action: `step ${step}`
    })
}
